module.exports = __webpack_public_path__ + "static/media/emoji-worst.b46dbf40.svg";